const transformListData = require("./transformListData");
const transformBannerData = require("./transformBannerData");
const transformAlertData = require("./transformAlertData");
const transformButtonsData = require("./transformButtonsData");
const transformVideoData = require("./transformVideoData");
const transformCallToActionData = require("./transformCallToActionData");
const transformContactCardData = require("./transformContactCardData");
const transformGalleryData = require("./transformGalleryData");
const transformHighlightData = require("./transformHighlightData");
const transformFormBlockData = require("./transformFormBlockData");
const transformResourcesData = require("./transformResourcesData");
const transformFieldsDisplayData = require("./transformFieldsDisplayData");
const transformEmbedData = require("./transformEmbedData");
const transformSliderData = require("./transformSliderData");
const extractMediaData = require("./extractMediaData");
const extractButtonData = require("./extractButtonData");
const slugify = require("./slugify");

module.exports = function transformBlockData({
	entity,
	sitemap,
	singleAttributes,
	singleRelationships,
	formsConfig,
	bundles,
	configs,
}) {
	let data;
	if (!entity.attributes) {
		return {
			id: entity.id,
			type: entity.type,
		};
	}
	switch (entity.type) {
		case "node--heading":
			data = {
				id: entity.id,
				title: entity.attributes.title,
				anchor: slugify(entity.attributes.title),
				type: entity.type,
				headingType: entity.attributes.field_heading_type,
				underline: entity.attributes.field_color_hex,
				align: entity.attributes.field_align,
				color: entity.attributes.field_color,
				html_tag: entity.attributes.field_html_tag,
				narrow: entity.attributes.field_narrow,
			};
			break;
		case "node--text":
			data = {
				id: entity.id,
				type: entity.type,
				text: entity.attributes.body
					? entity.attributes.body.transformed
						? entity.attributes.body.transformed
						: entity.attributes.body.value
					: "",
			};
			break;
		case "node--quote":
			data = {
				id: entity.id,
				type: entity.type,
				text: entity.attributes.body
					? entity.attributes.body.transformed
						? entity.attributes.body.transformed
						: entity.attributes.body.value
					: "",
				align: entity.attributes.field_align,
				style: entity.attributes.field_quote_style,
			};
			break;
		case "node--entities_list":
			data = transformListData(entity);
			break;
		case "node--image":
			data = {
				id: entity.id,
				type: entity.type,
				orientation: entity.attributes.field_image_orientation
					? entity.attributes.field_image_orientation
					: "full",
				clickable: entity.attributes.field_clickable,
				size: entity.attributes.field_size,
			};
			let image = extractMediaData(entity, null, sitemap);
			if (image) data = { ...data, ...image };
			break;
		case "node--gallery":
			data = transformGalleryData(entity, sitemap);
			break;
		case "node--banner_image":
			data = transformBannerData(entity);
			break;
		case "node--alert_banner":
			data = transformAlertData(entity);
			break;
		case "node--embed_code":
			data = transformEmbedData(entity);
			break;
		case "node--buttons":
			data = transformButtonsData(entity, sitemap, singleRelationships);
			data.title = entity.attributes.title;
			break;
		case "node--button":
			data = extractButtonData(entity, sitemap, singleRelationships);
			data.type = "node--button";
			break;
		case "node--video":
			data = transformVideoData(entity);
			break;
		case "node--call_to_action":
			data = transformCallToActionData(entity, sitemap);
			break;
		case "node--slider":
			data = transformSliderData(entity, sitemap);
			break;
		case "node--contact_card":
			data = transformContactCardData(entity, entity.attributes.field_name);
			break;
		case "node--highlight":
			data = transformHighlightData(entity, sitemap);
			break;
		case "node--resources":
			data = transformResourcesData(entity);
			break;
		case "node--fields_display":
			data = transformFieldsDisplayData({
				entity,
				singleAttributes,
				singleRelationships,
				fieldList: null,
				bundles,
				configs,
			});
			break;
		case "node--form":
			data = transformFormBlockData(entity, formsConfig);
			break;
		default:
			data = {
				...entity.attributes,
				id: entity.id,
				type: entity.type,
				relationships: entity.relationships,
			};
			break;
	}
	return data;
};
